/* eslint-disable no-shadow */
import { Grid } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import NoteAddIcon from '@material-ui/icons/NoteAdd'
import queryString from 'query-string'

import styles from '../../../resources/theme/global'
import {
  fetchServicesRelatoryInit,
  makeRelatory,
  clearFilter,
} from '../ServicesRelatoryActions'
import { getServicesRelatoryListData } from '../ServicesRelatoryReducer'

import Filter from './Filter'
import List from './List'

class ServicesRelatory extends Component {
  componentWillUnmount() {
    const { clearFilter } = this.props
    clearFilter()
  }

  makeReport = filters => {
    const values = queryString.parse(props.location.search)

    const filtersLeads = {
      type: 'dashboardLeads',
      status: values?.status,
      finalDate: values?.finalDate,
      startDate: values?.startDate,
    }

    if (values?.status) {
      makeRelatory(filtersLeads)
    } else {
      makeRelatory(filters)
    }
  }

  render() {
    const { classes, makeRelatory, filters } = this.props

    return (
      <>
        <Grid
          container
          className={classes.pageHead}
          spacing={1}
          alignItems="center"
        >
          <Grid item xs>
            <Typography variant="h4" color="secondary">
              Relatório de Atendimentos
            </Typography>
          </Grid>
          <Grid item>
            <Filter classes={classes} />
          </Grid>
          <Grid item>
            <Button
              color="primary"
              type="button"
              onClick={() => makeRelatory(filters)}
            >
              <NoteAddIcon className={classes.btnIcon} /> Relatório
            </Button>
          </Grid>
        </Grid>

        <List {...this.props} />
      </>
    )
  }
}

const mapStateToProps = state => ({
  ...getServicesRelatoryListData(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchServicesRelatoryInit,
      makeRelatory,
      clearFilter,
    },
    dispatch
  )
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ServicesRelatory))
